
// import { IPublicClientApplication, PublicClientApplication, BrowserCacheLocation } from '@azure/msal-browser';

import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER, Injectable, importProvidersFrom } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgxUiLoaderModule } from 'ngx-ui-loader';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { UserModule } from './user/user.module';
import { InboxService } from "./services/inbox.service";
import { DatePipe } from "@angular/common";
import { ErrorHandler } from "@angular/core";
import { GlobalErrorHandler } from "./global-error-handler";
import { ServerErrorInterceptor } from "./server-error.interceptor";
import { DateFormatPipe } from './common/pipes/date-format.pipe';
import { InquiryCache } from './common/cache/inquiry-cache';
import { ToastModule } from 'primeng/toast';
import { WebsocketService } from './services/websocket/websocket.service';
import { HammerGestureConfig, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { DashboardService } from './services/dashboard/dashboard.service';
import { NgxLoadingModule, ngxLoadingAnimationTypes } from '@dchtools/ngx-loading-v18';
import { ResponseInterceptor } from './services/http-response-interceptor';
import { SessionTimeOut } from './services/sessiontimeout.service';
import { AuthenticationInterceptor } from './services/http-interceptor';
import { MicrofrontendInboxModule } from './microfrontend-inbox/microfrontend-inbox.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { OAuthModule } from 'angular-oauth2-oidc';
import { OsNotificationService } from './services/os-notification/os-notification.service';
import { OsNotificationComponent } from './common/component/os-notification/os-notification.component';
import { environment } from '../environments/environment';
import { ERROR_MESSAGE_SETTER, WINDOW } from './app.tokens';
import { ErrorMessageService } from './services/error-message.service';

// MSAL Factory Function | // redirectUri: environment.REDIRECT_URI
// export function MSALInstanceFactory(): IPublicClientApplication {
//   return new PublicClientApplication({
//     auth: {
//       clientId: environment.ACTIVE_DIRECTORY_CLIENT_ID,
//       authority: 'https://login.microsoftonline.com/' + environment.ACTIVE_DIRECTORY_TENANT_ID,
//       redirectUri: environment.REDIRECT_URI
//     },
//     cache: {
//       cacheLocation: BrowserCacheLocation.LocalStorage
//     }
//   });
// }

@Injectable()
export class MyHammerConfig extends HammerGestureConfig {
  override overrides = <any>{
  };
  //C153176-5178:Added to fix the scroll blocking on swipe event on mailbox stats mobile
  override buildHammer(element: HTMLElement) {
    const mc = null;
    // retain support for angular overrides object
    for (const eventName of Object.keys(this.overrides)) {
      mc.get(eventName).set(this.overrides[eventName]);
    }
    return mc;
  }
}

export function initConfiguration(dashboardService: DashboardService) {
  return () => dashboardService.onLoad();
}

@NgModule({
  declarations: [
    AppComponent,
    DateFormatPipe,
    //SafePipe,
    //AttachmentViewerDialogComponent

  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    CoreModule,
    UserModule,
    NgxUiLoaderModule,
    NgxLoadingModule.forRoot({
      animationType: ngxLoadingAnimationTypes.circleSwish,
      backdropBackgroundColour: 'rgba(0,0,0,0.1)',
      backdropBorderRadius: '4px',
      primaryColour: '#021e48',
      secondaryColour: '#021e48',
      tertiaryColour: '#021e48',
      fullScreenBackdrop: true
    }),
    ToastModule,
    FontAwesomeModule,
    OAuthModule.forRoot(),
    MicrofrontendInboxModule,
    OsNotificationComponent
  ],
  providers: [
    InboxService,
    DashboardService,
    ErrorMessageService,
    { provide: ERROR_MESSAGE_SETTER, useExisting: ErrorMessageService },
    { provide: WINDOW, useFactory: () => (typeof window !== 'undefined' ? window : null) },
    WebsocketService,
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    { provide: HTTP_INTERCEPTORS, useClass: AuthenticationInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ServerErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ResponseInterceptor, multi: true },
    // { provide: APP_INITIALIZER, useFactory: initConfiguration, multi: true, deps: [DashboardService] },
    DatePipe,
    DateFormatPipe,
    InquiryCache,
    ToastModule,
    SessionTimeOut,
    {
      provide: HAMMER_GESTURE_CONFIG,
      useClass: MyHammerConfig,
    },
    importProvidersFrom(HttpClientModule),
    OsNotificationService,
    // MsalService // For MSAL
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }